<script setup lang="ts">
import { px } from '@/helpers/px'
import { useNotificationStore } from '@/store/notificationStore'

const store = useNotificationStore()
</script>

<template>
  <!-- Responsive -->
  <div>
    <div class="notification-wrapper" :style="{ top: px(store.topPosition) }">
      <div
        class="notification pd-row lo-h-center or-ft-white bd-3px"
        :class="`notification-${store.type}`"
        @click="store.hideNotification"
      >
        <img
          v-if="store.type === 'success'"
          src="@/assets/icons/success-circle-white.svg"
        />
        <img
          v-if="store.type === 'error'"
          src="@/assets/icons/error-circle-white.svg"
        />
        <div class="mg-left-8px">
          <div v-for="(message, index) in store.message" :key="index">
            {{ message }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.notification-wrapper {
  position: fixed;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 120;
  pointer-events: none;
  transition: top 0.3s ease-out;
}
.notification {
  max-width: 600px;
  background: white;
  pointer-events: auto;
  cursor: pointer;
}
.notification-success {
  background: var(--main);
}
.notification-error {
  background: var(--error);
}
@media screen and (max-width: 800px) {
  .notification-wrapper {
    margin: 0 var(--base-12px);
  }
}
</style>
